import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiAction } from "../../../api/ApiAction";
import { endpoints } from "../../../api/endpoints";
import { ICurrency } from "../../../api/types/directory/ICurrency";
import { RootState } from "../../rootState";

export const fetchCurrency = createAsyncThunk<ICurrency[], void, { state: RootState }>(
  "directory?getCurrency",
  async (param, thunkAPI) => {
    const result = await endpoints.directory.get(
      {
        action: ApiAction.getCurrency,
      },
      thunkAPI.signal,
    );

    return result as ICurrency[];
  },
);
